var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var ExploreIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 52,
    glyphHeight: 50
  }), React.createElement("path", {
    d: "M23.5238 38.125C23.5238 44.6834 18.2578 50 11.7619 50C5.26598 50 0 44.6834 0 38.125C0 31.5666 5.26598 26.25 11.7619 26.25C18.2578 26.25 23.5238 31.5666 23.5238 38.125ZM6.58141 38.125C6.58141 41.0136 8.9008 43.3553 11.7619 43.3553C14.623 43.3553 16.9424 41.0136 16.9424 38.125C16.9424 35.2364 14.623 32.8947 11.7619 32.8947C8.9008 32.8947 6.58141 35.2364 6.58141 38.125Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M28.4762 26.25C28.4762 27.6307 27.3676 28.75 26 28.75C24.6324 28.75 23.5238 27.6307 23.5238 26.25C23.5238 24.8693 24.6324 23.75 26 23.75C27.3676 23.75 28.4762 24.8693 28.4762 26.25Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M33.4286 21.25C33.4286 22.6307 32.3199 23.75 30.9524 23.75C29.5848 23.75 28.4762 22.6307 28.4762 21.25C28.4762 19.8693 29.5848 18.75 30.9524 18.75C32.3199 18.75 33.4286 19.8693 33.4286 21.25Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M38.381 16.25C38.381 17.6307 37.2723 18.75 35.9048 18.75C34.5372 18.75 33.4286 17.6307 33.4286 16.25C33.4286 14.8693 34.5372 13.75 35.9048 13.75C37.2723 13.75 38.381 14.8693 38.381 16.25Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M52 6.875C52 10.672 48.9513 13.75 45.1905 13.75C41.4297 13.75 38.381 10.672 38.381 6.875C38.381 3.07804 41.4297 0 45.1905 0C48.9513 0 52 3.07804 52 6.875Z",
    fill: "black"
  }));
};
export var ExploreIconGlyph = function (props) {
  return React.createElement(ExploreIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};